import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';

@Component({
  selector: 'neo-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainFooterComponent implements OnInit {
  @Input() mainFooterTop = true;
  @Input() menuIdiomas = true;
  @Input() menuFooter = true;
  @Input() menuSocial = true;
  @Input() elementosMenu = [];
  @Input() elementosIdioma =  [
    {
        nombre: 'Esp',
        codigo: 'es',
        url: '#',
        hijos: [
            {
                nombre: 'Esp',
                codigo: 'es',
                // url: 'http://htdocs.local/unef-matrix/es/',
                url: '#'
            },
            {
                nombre: 'Eng',
                codigo: 'en',
                // url: 'http://htdocs.local/unef-matrix/en/',
                url: '#'

            }
        ]
    }];
    
  direccion;
  linkDireccion;
  tituloDireccion;
  telefono;
  email;
  nombreComercial = this.preferenciasService.get('matrix_nombreComercial');
  direccionesAdicionales = [];
  fechaActual = new Date();

  constructor(
    public preferenciasService: PreferenciasService,
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
    ) { }

  ngOnInit(): void {
   this.iniciarPagina();
  }

  iniciarPagina() {
    if (this.helpersService.hayModulo('edicion')) {
      this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-hq').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;
          this.tituloDireccion = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-tit', indice);   
          this.direccion = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-txt', indice); 
          this.linkDireccion = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-lnk', indice);        
          this.telefono = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-tel1', indice);        
          this.email = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-mail1', -1);        
        })
      })
      // this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-sedes').subscribe(data => {
      //   data.elementos.forEach((elemento, index) => {
      //     let tituloSede =  this.edicionSeccionesService.getCamposEdicionItem(elemento, `sede-tit`, index);
      //     let direccionSede =  this.edicionSeccionesService.getCamposEdicionItem(elemento, `sede-dir`, index);
      //     this.direccionesAdicionales.push({
      //       titulo: tituloSede,
      //       direccion: direccionSede
      //     })
      //   })
      // })
    } else {
      this.direccion = this.preferenciasService.get('contacto_direccionMostrar');
      this.telefono = this.preferenciasService.get('contacto_telefono');
      this.email = this.preferenciasService.get('contacto_email');
    }
  }
  
  get mostrarUbicaciones() {
    return this.direccion || this.telefono || this.email;
  }

  mathCeil(a) {
    return Math.ceil(a);
  }

  mathFloor(a) {
    return Math.floor(a);
  }


}
